function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.3,33.3c0,1.2-1.3,2-3.3,2s-3.3-0.8-3.3-2V6c0-1.3,1.3-2,3.3-2s3.3,0.8,3.3,2V33.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24,33.3c0,1.2-1.3,2-3.3,2s-3.3-0.8-3.3-2V6c0-1.3,1.3-2,3.3-2S24,4.7,24,6L24,33.3z"
}));

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.6 39.3",
    style: {
      enableBackground: "new 0 0 26.6 39.3"
    },
    xmlSpace: "preserve"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI1LjIuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAyNi42IDM5LjMiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI2LjYgMzkuMzsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KCTxwYXRoIGQ9Ik05LjMsMzMuM2MwLDEuMi0xLjMsMi0zLjMsMnMtMy4zLTAuOC0zLjMtMlY2YzAtMS4zLDEuMy0yLDMuMy0yczMuMywwLjgsMy4zLDJWMzMuM3oiLz4KCTxwYXRoIGQ9Ik0yNCwzMy4zYzAsMS4yLTEuMywyLTMuMywycy0zLjMtMC44LTMuMy0yVjZjMC0xLjMsMS4zLTIsMy4zLTJTMjQsNC43LDI0LDZMMjQsMzMuM3oiLz4KPC9nPgo8L3N2Zz4K";
export { SvgPause as ReactComponent };